<template>
    <div class="b1t-okraina-actions">
        <div class="container">
            Акции
        </div>
    </div>
</template>

<script>
    export default {
        name: 'b1t-okraina-actions'
    }
</script>

<style lang="scss">
    
</style>